import { Tooltip } from "@mui/material";
import { GridRow, GridRowProps } from "@mui/x-data-grid-pro";
import { useTheme } from '@mui/material/styles';
import { useState } from "react";

interface IWorkItemRowProps {
    props: GridRowProps;
    validateRow: (props: GridRowProps) => { checked: boolean, valid: boolean };
    getRowErrorMessage: (props: GridRowProps) => string;
}

const WorkItemRow = ({ props, validateRow, getRowErrorMessage }: IWorkItemRowProps) => {
    const theme = useTheme();
    const [isHovered, setIsHovered] = useState(false);
    const { checked, valid: isValid } = validateRow(props);
    const errorMessage = !checked ? '' : getRowErrorMessage(props);
    const newProps: GridRowProps = { ...props };
    newProps.className += props.index % 2 === 0 ? ' row even' : ' row odd';
    if (checked && !isValid) {
        newProps.style = { ...newProps.style, backgroundColor: theme.palette.error.background };
        newProps.className += ' validation-error';
    } else if (checked && isValid) {
        newProps.style = { ...newProps.style, backgroundColor: theme.palette.success.background };
        newProps.className += ' validation-success';
    }
    return (
        <>
            {checked &&
                <Tooltip
                    sx={{ fontSize: '14px' }}
                    title={errorMessage}
                    open={isHovered} arrow>
                    <GridRow
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        {...newProps} />
                </Tooltip>
                || <GridRow {...newProps} />}
        </>
    );
}

export default WorkItemRow;